import Integration from '../models/Integration'

export default function createPrayer(integrationsBase, { id: integrationId }, fields) {
  const integration = new Integration(integrationsBase, integrationId)
  return integration.makeServiceRequest('create_prayer', { ...fields })
}
